import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { baseUrl } from "../../../Config/baseUrl";
import { useFormik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import ViewMetaDetails from "../../Metadetails/ViewDetails";

const BookMeta = ({ formik }) => {
  const { id } = useParams();
  const { state } = useLocation();
  const { type } = useParams();
  const [data, setData] = useState();
  const navegate = useNavigate();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Meta_title</p>
          <input
            id="meta_title"
            placeholder="Enter title"
            value={formik.values.meta_title}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Meta_tag"</p>
          <input
            id="meta_tag"
            placeholder="Enter Website Name"
            value={formik.values.meta_tag}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">meta_keyword</p>
          <input
            id="keyword"
            value={formik.values.keyword}
            placeholder="Enter Some word about Website"
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Meta_Description</p>
          <input
            id="meta_description"
            placeholder="Enter about Your Website"
            value={formik.values.meta_description}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">canonical</p>
          <input
            id="canonical"
            placeholder="Enter your wesite url"
            value={formik.values.canonical}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Og_Title</p>
          <input
            id="og_title"
            value={formik.values.og_title}
            placeholder="Enter some word about Website"
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">og_locale</p>
          <input
            id="og_locale"
            placeholder="en_US"
            value={formik.values.og_locale}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>

      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Og_Image</p>
          <input
            id="og_image"
            type="file"
            placeholder="image"
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={(event) =>
              formik.setFieldValue("og_image", event.target.files[0])
            }
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Og_Discription</p>
          <input
            id="og_discription"
            placeholder="Enter Og descrition is somthing  ..."
            value={formik.values.og_discription}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Og Type</p>
          <input
            id="og_type"
            value={formik.values.og_type}
            placeholder="website"
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Og Sitename</p>
          <input
            id="og_sitename"
            placeholder="website Name"
            value={formik.values.og_sitename}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>

      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold"> og_url</p>
          <input
            id="og_url"
            placeholder=" Enter your site url"
            value={formik.values.og_url}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">fb_admin</p>
          <input
            id="fb_admin"
            placeholder="Enter your website name "
            value={formik.values.fb_admin}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Og_twitter</p>
          <input
            id="twitter_title"
            placeholder="Enter website url"
            value={formik.values.twitter_title}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">twitter_card</p>
          <input
            id="twitter_card"
            placeholder="about website summary"
            value={formik.values.twitter_card}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">twitter_description</p>
          <input
            id="twitter_description"
            placeholder="this is my website at work on may types of web development"
            value={formik.values.twitter_description}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3">
        <div>
          <p className="p-1 text-sm font-semibold">twitter_site</p>
          <input
            id="twitter_site"
            value={formik.values.twitter_site}
            placeholder="Enter your website url"
            className="w-full p-2 px-4 m-1 placeholder-gray-500 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>

      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Url</p>
          <input
            id="url"
            value={formik.values.url}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
            placeholder="https//yourwebsite.com/"
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">twitter_image</p>
          <input
            id="twitter_image"
            type="file"
            placeholder="Enter Image"
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={(event) =>
              formik.setFieldValue("twitter_image", event.target.files[0])
            }
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">lang</p>
          <input
            id="lang"
            placeholder="en_US"
            value={formik.values.lang}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Alternate</p>
          <input
            id="alternate"
            placeholder="https//yourwebsite.com/"
            value={formik.values.alternate}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">Robots</p>
          <input
            id="robots_txt"
            value={formik.values.robots_txt}
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
            placeholder="index,follow"
          />
        </div>
      </div>
      <div className="w-full pl-3 ">
        <div>
          <p className="p-1 text-sm font-semibold">schema</p>
          <input
            id="schema"
            value={formik.values.schema}
            placeholder="about business"
            className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
            onChange={formik.handleChange}
          />
        </div>
      </div>
      {/* <div className="w-full pl-3 ">
        <Button type="submit" variant="contained">
          Add
        </Button>
      </div> */}
      {/* {!hideButton && (
                    <div className="w-full pl-3 ">
                      <Button type="submit" variant="contained">
                        Add
                      </Button>
                    </div>
                  )} */}
    </div>
  );
};

export default BookMeta;
